import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


interface Config {
    tpscBaseUrl?: string | null
};

const initialState: Config = {
    tpscBaseUrl: null,
};

export const configSlice = createSlice({
    name : "Config",
    initialState,
    reducers: {
        setConfig: (state: Config, action: PayloadAction<string>) => {
            state.tpscBaseUrl = action.payload
        },
        clearConfig: (state: Config) => {
            state.tpscBaseUrl = null
        }
    }
});

export const { setConfig, clearConfig } = configSlice.actions;

export default configSlice.reducer;